import { Tabs, TabsProps, View } from 'tamagui'
import { forwardRef, useRef, useState } from 'react'

interface ScrollableTabsProps {
    value: string
    onChange: (value: string) => void
    children: React.ReactNode
}

interface ScrollableTabListProps {
    children: React.ReactNode
}

export const ScrollableTabList = forwardRef<HTMLDivElement, ScrollableTabListProps>(
    ({ children }, ref) => {
        const [isMouseDown, setIsMouseDown] = useState(false)
        const [startX, setStartX] = useState(0)
        const [scrollLeft, setScrollLeft] = useState(0)
        const [isDragging, setIsDragging] = useState(false)

        const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
            setIsMouseDown(true)
            setIsDragging(false)
            setStartX(e.pageX - e.currentTarget.offsetLeft)
            setScrollLeft(e.currentTarget.scrollLeft)
        }

        const handleMouseLeave = () => setIsMouseDown(false)
        const handleMouseUp = () => setIsMouseDown(false)

        const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
            if (!isMouseDown) return
            e.preventDefault()
            const x = e.pageX - e.currentTarget.offsetLeft
            const walk = x - startX
            if (Math.abs(walk) > 5) {
                setIsDragging(true)
            }
            e.currentTarget.scrollLeft = scrollLeft - walk
        }

        return (
            <Tabs.List
                onMouseDown={handleMouseDown as any}
                onMouseLeave={handleMouseLeave as any}
                onMouseUp={handleMouseUp as any}
                onMouseMove={handleMouseMove as any}
                onClick={(e: any) => {
                    if (isDragging) {
                        e.preventDefault()
                    }
                }}

                overflow="auto"
                borderBottomWidth={1}
                borderBottomColor="$borderColor"
                borderBottomLeftRadius={0}
                borderBottomRightRadius={0}
                // @ts-ignore - webkit scrollbar hiding
                style={{
                    WebkitOverflowScrolling: 'touch',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                }}
            >
                {children}
            </Tabs.List>
        )
    },
)

export const ScrollableTabs = ({ value, onChange, children }: ScrollableTabsProps) => {
    return (
        <Tabs
            value={value}
            onValueChange={(val) => {
                if (val !== null) {
                    onChange(val)
                }
            }}
            orientation="horizontal"
        >
            {children}
        </Tabs>
    )
}
